export default {"src":"/_next/static/image/public/images/ic_heart_mandalay.6c00f0deb815bd5e02181a136a8f5418.svg","height":14,"width":16};